import type { ReactElement, SVGProps } from "react";

export function RefundIcon(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.95 15.3578L16.4578 9.85005L15.2943 8.68655L10.95 13.0308L8.7365 10.8173L7.573 11.9808L10.95 15.3578ZM12 21.8116C9.77433 21.2154 7.92625 19.9109 6.45575 17.8981C4.98525 15.8852 4.25 13.6192 4.25 11.1001V5.1423L12 2.22705L19.75 5.1423V11.1001C19.75 13.6192 19.0148 15.8852 17.5443 17.8981C16.0738 19.9109 14.2257 21.2154 12 21.8116Z"
        fill="#9600F1"
      />
    </svg>
  );
}
